import React from 'react';

const NotFound = () => {
  return (<h1>This is NotFound</h1>)
}

export default NotFound